import React, { useEffect, useState } from 'react'
import { Button, ConfigProvider, Form, Input, InputNumber, Modal, Radio, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { FormButton } from '../group.styled'
import { addBrand, modifyBrand } from '../../../apis/brand'
import { useSelector } from 'react-redux'

function BrandModal (props) {
  const { show, setShow, data, successCallback = () => {}, adminMode, groupsOption } = props
  const { t: ln_t } = useTranslation()
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)
  const user = useSelector((state) => state.user)

  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`group.${name}`)}`
  }
  const defConfig = (name, type, required = true) => ({ name, label: ln_t(`group.${name}`), rules: [{ required, message: defPlaceholder(name, type) }] })

  const handleClose = () => {
    setShow(false)
    form.resetFields()
  }

  const handleSave = async value => {
    const { segmentLimit, groupId: group, ...other } = value || {}
    const groupId = !adminMode ? user?.nowGroup : data?.addMode ? group : data?.groupId
    const reqBody = { ...other, limits: { segmentLimit }, groupId }
    const addMode = !data || data?.addMode
    setIsLoading(true)
    const res = addMode ? await addBrand(reqBody) : await modifyBrand(data?.id, reqBody)
    if (res?.status === (addMode ? 201 : 200)) {
      successCallback(data?.id)
      handleClose()
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (!data || data?.addMode) return form.resetFields()
    const { name, status, limits, groupId } = data
    form.setFieldsValue({ name, status, segmentLimit: limits?.segmentLimit, groupId })
  }, [show])

  return (
    <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
      <Modal title={`${ln_t(`util.${data && !data?.addMode ? 'edit' : 'add'}`)} ${ln_t('user.brand')}`} open={show} onCancel={handleClose} footer={null}>
        <Form form={form} layout="vertical" requiredMark={false} onFinish={e => handleSave(e)} style={{ marginTop: '16px' }}>
          {adminMode
            ? <Form.Item {...defConfig('group', 'select')} name="groupId">
                <Select showSearch disabled={!data?.addMode} placeholder={defPlaceholder('group', 'select')} options={groupsOption} optionFilterProp="children"/>
              </Form.Item>
            : ''}
          <Form.Item {...defConfig('name', 'input')}>
            <Input placeholder={defPlaceholder('name', 'input')} />
          </Form.Item>
          <Form.Item {...defConfig('segmentLimit', 'input')}>
            <InputNumber placeholder={defPlaceholder('segmentLimit', 'input')} max={1000} min={0} precision={0} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item {...defConfig('status', 'select')} initialValue={1}>
            <Radio.Group
              options={[{ value: 1, label: ln_t('util.enable') }, { value: 0, label: ln_t('util.disable') }]}
              optionType="button"
              buttonStyle="solid"
            />
          </Form.Item>
          <FormButton>
            <Button type="default" onClick={handleClose}>{ln_t('util.cancel')}</Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>{ln_t('util.confirm')}</Button>
          </FormButton>
        </Form>
      </Modal>
    </ConfigProvider>
  )
}

export default BrandModal
